import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box } from "../Box/index.js";
import { Icon } from "../Icon/index.js";
import Checkbox_styles from "./Checkbox.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Checkbox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Checkbox_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const Checkbox_Checkbox = (t0)=>{
    const $ = c(51);
    let checked;
    let className;
    let disabled;
    let indeterminate;
    let rest;
    let stopPropagation;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    if ($[0] !== t0) {
        ({ className, checked, disabled, indeterminate, onChange: t1, stopPropagation, verticalClickArea: t2, testId, withoutMargin: t3, sizeVariant: t4 } = t0), rest = _object_without_properties(t0, [
            "className",
            "checked",
            "disabled",
            "indeterminate",
            "onChange",
            "stopPropagation",
            "verticalClickArea",
            "testId",
            "withoutMargin",
            "sizeVariant"
        ]);
        $[0] = t0;
        $[1] = checked;
        $[2] = className;
        $[3] = disabled;
        $[4] = indeterminate;
        $[5] = rest;
        $[6] = stopPropagation;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = testId;
    } else {
        checked = $[1];
        className = $[2];
        disabled = $[3];
        indeterminate = $[4];
        rest = $[5];
        stopPropagation = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        testId = $[11];
    }
    const onChange = void 0 === t1 ? _temp : t1;
    const verticalClickArea = void 0 === t2 ? 0 : t2;
    const withoutMargin = void 0 === t3 ? false : t3;
    const sizeVariant = void 0 === t4 ? "default" : t4;
    let t5;
    if ($[12] !== verticalClickArea) {
        t5 = {
            verticalClickArea
        };
        $[12] = verticalClickArea;
        $[13] = t5;
    } else t5 = $[13];
    const { classes } = Checkbox_styles(t5);
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx(Icon, {
            name: "check_box_off",
            size: "24"
        });
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== classes.iconUnchecked) {
        t7 = /*#__PURE__*/ jsx(Box, {
            className: classes.iconUnchecked,
            children: t6
        });
        $[15] = classes.iconUnchecked;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsx(Icon, {
            name: "check_box_on",
            size: "24"
        });
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== classes.iconChecked) {
        t9 = /*#__PURE__*/ jsx(Box, {
            className: classes.iconChecked,
            children: t8
        });
        $[18] = classes.iconChecked;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsx(Icon, {
            name: "check_box_indetermanate",
            size: "24"
        });
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== classes.iconChecked) {
        t11 = /*#__PURE__*/ jsx(Box, {
            className: classes.iconChecked,
            children: t10
        });
        $[21] = classes.iconChecked;
        $[22] = t11;
    } else t11 = $[22];
    const t12 = "default" === sizeVariant;
    const t13 = "large" === sizeVariant;
    let t14;
    if ($[23] !== className || $[24] !== classes.input || $[25] !== classes.sizeDefault || $[26] !== classes.sizeLarge || $[27] !== classes.verticalClickArea || $[28] !== classes.withoutMargin || $[29] !== t12 || $[30] !== t13 || $[31] !== withoutMargin) {
        t14 = classnames("aqa_checkbox", classes.input, classes.verticalClickArea, {
            [classes.withoutMargin]: withoutMargin,
            [classes.sizeDefault]: t12,
            [classes.sizeLarge]: t13
        }, className);
        $[23] = className;
        $[24] = classes.input;
        $[25] = classes.sizeDefault;
        $[26] = classes.sizeLarge;
        $[27] = classes.verticalClickArea;
        $[28] = classes.withoutMargin;
        $[29] = t12;
        $[30] = t13;
        $[31] = withoutMargin;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== onChange) {
        t15 = (event)=>{
            event.stopPropagation();
            onChange(event.target.checked);
        };
        $[33] = onChange;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== checked || $[36] !== disabled || $[37] !== indeterminate || $[38] !== rest || $[39] !== t11 || $[40] !== t14 || $[41] !== t15 || $[42] !== t7 || $[43] !== t9 || $[44] !== testId) {
        t16 = /*#__PURE__*/ jsx(Checkbox, _object_spread_props(_object_spread({}, rest), {
            checked: checked,
            "data-testid": testId,
            icon: t7,
            checkedIcon: t9,
            indeterminateIcon: t11,
            className: t14,
            color: "primary",
            disabled: disabled,
            indeterminate: indeterminate,
            onChange: t15
        }));
        $[35] = checked;
        $[36] = disabled;
        $[37] = indeterminate;
        $[38] = rest;
        $[39] = t11;
        $[40] = t14;
        $[41] = t15;
        $[42] = t7;
        $[43] = t9;
        $[44] = testId;
        $[45] = t16;
    } else t16 = $[45];
    const checkbox = t16;
    if (stopPropagation) {
        let t17;
        if ($[46] !== classes.controlLabel) {
            t17 = {
                root: classes.controlLabel
            };
            $[46] = classes.controlLabel;
            $[47] = t17;
        } else t17 = $[47];
        let t18;
        if ($[48] !== checkbox || $[49] !== t17) {
            t18 = /*#__PURE__*/ jsx(FormControlLabel, {
                classes: t17,
                onClick: _temp2,
                onFocus: _temp3,
                control: checkbox,
                label: ""
            });
            $[48] = checkbox;
            $[49] = t17;
            $[50] = t18;
        } else t18 = $[50];
        return t18;
    }
    return checkbox;
};
function _temp() {}
function _temp2(event_0) {
    return event_0.stopPropagation();
}
function _temp3(event_1) {
    return event_1.stopPropagation();
}
export { Checkbox_Checkbox as Checkbox };
